const MEMBERS_HEADERS = [
    { name: 'Email', value: 'email' },
    { name: 'Status', value: 'accepted', align: 'center' },
]

const ACTIONS_COLUMN = {
    name: 'Actions', value: 'actions', minWidth: 114, align: 'center',
}

const MEMBERS_HEADERS_WITH_ACTIONS = [
    ...MEMBERS_HEADERS,
    ACTIONS_COLUMN,
]

export {
    MEMBERS_HEADERS,
    MEMBERS_HEADERS_WITH_ACTIONS,
}
